import { useMemo } from 'react';
import { normalizeScoringConfig } from '../utils/gameScoreRules';

/**
 * Derive scoring config from a session record.
 * @param {object|null|undefined} session
 */
export function useSessionScoringConfig(session) {
  return useMemo(
    () => normalizeScoringConfig(session),
    [session?.points_target, session?.deuce_mode],
  );
}
